import React from 'react';

import { cn } from '@plato/ui/util/classes';

type CardProps = {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
    children?: React.ReactNode;
};

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ children, className, onClick, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(
                    'flex flex-col gap-3',
                    'bg-white border border-solid border-neutral-100 px-3 py-2 rounded-lg text-left ',
                    {
                        'cursor-pointer hover:border-neutral-300': Boolean(onClick),
                    },
                    className,
                )}
                {...props}
                onClick={onClick}
                aria-hidden="true"
                role="button"
            >
                {children}
            </div>
        );
    },
);

Card.displayName = 'Card';
